import { render, staticRenderFns } from "./info-window.vue?vue&type=template&id=2497d372&"
import script from "./info-window.vue?vue&type=script&lang=js&"
export * from "./info-window.vue?vue&type=script&lang=js&"
import style0 from "./info-window.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports